import { SummaryModel } from '../../../../../common/entity/summary.model';
import { PermissionsModel } from '../../../../../common/entity/permissions.model';

export class WorkflowTaskAttributeSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    name: string;
    value: string;
    resultAttribute: boolean;
}
